import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export const updateEventState = (payload, path) => {
    return {
        type: actionTypes.UPDATE_EVENT_STATE,
        payload,
        path
    }
}

export const getEventsData = data => {
    return dispatch => {
        dispatch({
            type: actionTypes.EVENTS_LOADING,
        });
        API.getEventsData(data, (error, response) => {
            log('get all events response', response);
            if (!error && response.data && response.data.events) {
                dispatch({
                    type: actionTypes.EVENTS_LOADED,
                    payload: response.data.events
                });
            } else {
                dispatch({
                    type: actionTypes.EVENTS_ERROR,
                });
            }
        });
    };
}

export const getEventDetails = (data, callback) => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "Event details loading"
        });
        API.getEventDetails(data, (error, response) => {
            log('event detail', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && callback) {
                if (response && response.data && response.data.eventDetails) {
                    callback(response.data.eventDetails);
                } else {
                    showMessage('error', 'event detail is missing');
                }
            }
        });
    };
}

export const createEvent = (data, closeModal) => {
    return dispatch => {
        dispatch({
            type: actionTypes.UPDATE_EVENT_LOADING,
        });
        API.createEvent(data, (error, response) => {
            log('event created', response);
            dispatch({
                type: actionTypes.UPDATE_EVENT_LOADED,
            });
            if (!error) {
                dispatch({
                    type: actionTypes.EVENT_CREATED,
                    payload: response,
                });
                if (closeModal) closeModal();
                showMessage('success', response && response.message ? response.message : 'EVENT successfully created');
            }
        });
    };
}

export const updateEvent = (data, closeModal) => {
    return dispatch => {
        dispatch({
            type: actionTypes.UPDATE_EVENT_LOADING,
        });
        API.updateEvent(data, (error, response) => {
            dispatch({
                type: actionTypes.UPDATE_EVENT_LOADED,
            });
            log('event created', response);
            if (!error) {
                dispatch({
                    type: actionTypes.EVENT_UPDATED,
                    payload: response,
                });
                if (closeModal) closeModal();
                showMessage('success', response && response.message ? response.message : 'EVENT successfully updated');
            }
        });
    };
}

export const deleteEvent = payload => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "event deleting"
        });

        API.deleteEvent(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error) {
                dispatch({
                    type: actionTypes.EVENT_DELETED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'EVENT successfully deleted');
            }
        });
    };
}

//----------------------------- Event Analytics ----------------------------------

export const getEventHistogram = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.EVENT_HISTOGRAM_LOADING,
        });
        API.getEventHistogram(payload, (error, response) => {
            log('event histogram data', response);
            if (callback) callback();
            if (!error && response) {
                dispatch({
                    type: actionTypes.EVENT_HISTOGRAM_RECEIVED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.EVENT_HISTOGRAM_LOAD_ERROR,
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/event_details/actions.js